import { api, extractApiErrorMessage } from '../api/client';
import { ROUTES } from '../api/routes';

type PushApiRequestOptions = {
  bearerToken?: string;
};

export type RegisterPushTokenInput = {
  fcmToken: string;
  plataforma?: 'WEB' | string;
  tipo?: string;
};

function authSurfaceConfig(options?: PushApiRequestOptions) {
  const config: any = {};
  const bearerToken = options?.bearerToken?.trim();
  if (bearerToken) {
    config.headers = {
      'X-AC-Use-Bearer': 'true',
    };
    config._acBearerToken = bearerToken;
  }
  return config;
}

export async function registerAuthenticatedPushToken(
  input: RegisterPushTokenInput,
  options?: PushApiRequestOptions,
): Promise<unknown> {
  try {
    const { data } = await api.post(
      ROUTES.auth.pushRegister,
      input,
      authSurfaceConfig(options),
    );
    return data;
  } catch (err) {
    throw new Error(extractApiErrorMessage(err, 'Falha ao registrar token push.'));
  }
}
